module.exports = __webpack_public_path__ + "img/chongwu1.1565d8a1.png";